import { type MaybeRefOrGetter, toRef, watch } from 'vue'

import { type HttpApiError, paymentAPI } from '@backmarket/http-api'
import type { GetNextActionResponse } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import type { UseHttpFetchOptions } from '@backmarket/nuxt-module-http/UseHttpFetchOptions'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

/**
 * Automatically get the next action via `useHttpFetch` when the payment id changes.
 * When the payment id is not defined, it does not fetch anything.
 */
export const usePaymentNextAction = (
  paymentId: MaybeRefOrGetter<string | undefined>,
  options: UseHttpFetchOptions<GetNextActionResponse, HttpApiError>,
) => {
  const httpFetchResult = useHttpFetch(paymentAPI.getNextAction, {
    ...options,
    immediate: false,
    pathParams: {
      paymentId: toRef(paymentId),
    },
  })

  watch(
    toRef(paymentId),
    (newPaymentId, oldPaymentId) => {
      if (newPaymentId && newPaymentId !== oldPaymentId) {
        void httpFetchResult.execute()
      }
    },
    { immediate: true },
  )

  return httpFetchResult
}
